import styled from 'styled-components';

export const Container = styled.div`
  &.loading {
    display: none;
  }
`;
